import FindRecipientPersonaType from 'owa-recipient-types/lib/types/FindRecipientPersonaType';

export default function getDisplayNameFromFindRecipientPersonaType(
    findRecipient: FindRecipientPersonaType
): string {
    return findRecipient.EmailAddress.Name || findRecipient.DisplayName;
}
